import { common } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';
import shadows from './shadows';
import typography from './typography';

// This is the legacy theme - keeping for backward compatibility
// The new theme system is in src/context/ThemeContext.js
const theme = createTheme({
  palette: {
    background: {
      default: '#f5f5f5',
      paper: common.white,
      main: 'linear-gradient(180deg, rgba(240, 240, 240, 1), rgba(226, 225, 231, 1))',
    },
    primary: {
      contrastText: '#FEFEFE',
      main: '#0B6E99'
    },
    secondary: {
      main: '#2b2d42'
    },
    text: {
      primary: '#172b4d',
      secondary: '#6b778c'
    },
    success: {
      main: '#16CB77',
      secondary: '#14C990'
    },
  },
  shadows,
  typography,
});

export default theme;
